/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";
import { isBoolean } from "utils/lodashUtils";

class FABStore {
  @observable showFAB;
  @observable FABVerbId;
  @observable fabComponent;

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.FABVerbId = null;
    this.showFAB = false;
  }

  @action.bound
  setFABVisibility(value) {
    this.showFAB = value;
  }

  @action
  setFABComponent(component) {
    this.fabComponent = component;
  }

  @action
  registerFABVerbId(verbId, opts = {}) {
    this.FABVerbId = verbId;
    const { visibility, component } = opts;
    if (isBoolean(visibility)) {
      this.setFABVisibility(opts.visibility);
    }
    if (component) {
      this.setFABComponent(component);
    }
  }
}

export { FABStore };
